/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPenNib} from '@fortawesome/pro-duotone-svg-icons';

const AuthorsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faPenNib} {...props} />
);

export default AuthorsIcon;
